export enum Puestos {
    RECAMARISTA = "Camarista",
    MANTENIMIENTO = "Mantenimiento",
    SUPERVISOR = "Supervisor",
    AMALLAVES = "Ama de llaves",
    LAVANDERIA = "Lavandería",
    CHEF = "Chef",
    COCINERO = "Cocinero",
    AYUDANTECOCINA = "Ayudante de cocina",
    MESERO = "Mesero",
    BARTENDER = "Bartender",
    LAVALOZA = "Lavaloza",
}
export const puestosConModuloRestaurante = ["Supervisor", "Ama de llaves", "Camarista", "Lavandería", "Mantenimiento", "Chef", "Cocinero", "Ayudante de cocina", "Mesero", "Bartender", "Lavaloza"]

export const puestosHospedaje = ["Supervisor", "Ama de llaves", "Camarista", "Lavandería", "Mantenimiento"]

export const puestosRestaurante = ["Chef", "Cocinero", "Ayudante de cocina", "Mesero", "Bartender", "Lavaloza"]

export const puestosSinModuloRestaurante = ["Supervisor", "Camarista", "Mantenimiento"]
